import React, { useState, useEffect } from 'react';
import QRCode from "qrcode";

const PreviewTeo = ({ show, onHide, content, count = 1, scale }) => {
  const [qrCode, setQrCode] = useState("");

  // ============================================================
  // GENERATE QR CODE (links to Lerros HQ contact page)
  // ============================================================
  useEffect(() => {
    const generateQR = async () => {
      try {
        const qrData = "https://company.lerros.com/de/kontakt/zentrale";
        const qr = await QRCode.toDataURL(qrData, {
          width: 150,
          margin: 0,
          errorCorrectionLevel: "M",
        });
        setQrCode(qr);
      } catch (error) {
        console.error("QR Code generation error:", error);
        setQrCode("");
      }
    };
    generateQR();
  }, []);

  // ============================================================
  // HELPERS (same output as before, just less repetition)
  // ============================================================
  const qty = (i) =>
    content?.TotalQtys?.[i] === 0 || content?.TotalQtys?.[i] === "0"
      ? ""
      : content?.TotalQtys?.[i] || "";

  const pieceClasses = [
    "peiceDiv", "peiceDiv1", "peiceDiv", "peiceDiv",
    "peiceDiv1", "peiceDiv1", "peiceDiv1", "peiceDiv1",
    "peiceDiv", "peiceDiv1", "peiceDiv1", "peiceDiv2", "peiceDiv3",
  ];

  const sizeCells = Array.from({ length: 12 }, (_, i) => `
          <hr class="hr-style-3" />
          <div style="height: 44px; width: 74px; padding: 5px">
            <h2>${content?.header?.[i] || ""}</h2>
          </div>`).join("");

  const pieceCells = pieceClasses.map((cls, i) => `
          <div class="${cls}"><h2>${qty(i)}</h2></div>`).join("");

  // ============================================================
  // LABEL HTML
  // STRUCTURE:
  //   .label-wrap
  //     ├── .qr-main-div  (red border -> contains only .table)
  //     └── .container_1_qr (QR, outside the border on the right)
  // ============================================================
  const tbl = `
<div class="label-wrap">

  <div class="qr-main-div">
    <div class="table">

      <div class="table-row">
        <div class="common-first-cell article-cell">
          <div>ARTICLE NO.</div>
          <div class="common-first-cell first-inner-div">
            <h1>${content?.STY || "STY"}</h1>
          </div>
          <div class="">
            <hr class="hr-style-1" />
            NVE BARCODE
          </div>
        </div>
        <div class="common-first-cell color-cell">
          <div>COLOR</div>
          <div class="common-first-cell first-inner-div-clr">
            <div><h2>${content?.CLRS?.[0] || "000"}</h2></div>
            <div><h2>${content?.CLRS?.[1] || ""}</h2></div>
            <div><h2>${content?.CLRS?.[3] ? "***" : content?.CLRS?.[2] || ""}</h2></div>
          </div>
        </div>
        <div class="common-first-cell lot-cell">
          <span>LOT</span>
          <div class="common-first-cell first-inner-div-lot">
            <div><h2>${content?.LOTS?.[0] || "000"}</h2></div>
            <div><h2>${content?.LOTS?.[1] || ""}</h2></div>
            <div><h2>${content?.LOTS?.[3] ? "***" : content?.LOTS?.[2] || ""}</h2></div>
          </div>
        </div>
        <div class="common-first-cell lot-count-cell">
          <div>NO. OF LOT</div>
          <div class="common-first-cell first-inner-div-lots"><h2>${content?.NoOfLots || 1}</h2></div>
        </div>
        <div class="common-first-cell po-cell">
          <div>PO NUMBER</div>
          <div class="common-first-cell first-inner-div">
            <h1>${content?.PO || ""}</h1>
          </div>
        </div>
      </div>

      <div class="table-row">
        <div class="common-cell barcode-cell">
          <svg></svg>
          <div class="table-row" style="padding: 0;">
            <div class="common-cell carton-and-qlt-pieces-cell" style="border-left: none;">
              <div>CARTON NO.</div>
              <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.SNO || "1"}</h3></div>
            </div>
            <div class="common-cell carton-and-qlt-pieces-cell">
              <div>QTY PIECES</div>
              <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.QtyPcs || "1"}</h3></div>
            </div>
            <div class="common-cell gross-and-net-wt-cell">
              <div>GROSS WT(KG)</div>
              <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.GrossWt || "1"}</h3></div>
            </div>
            <div class="common-cell gross-and-net-wt-cell" style="border-right: none;">
              <div>NET WT(KG)</div>
              <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.NetWt || "1"}</h3></div>
            </div>
          </div>
        </div>

        <div class="common-cell special-marking-cell-new">
          <div>SPECIAL MARKING/CUSTOMER PO NO</div>
          <div><h3 style="font-size: 25px;">${content?.SINF?.split(",")[1] ? content?.SINF.split(",")[1] : ' '}</h3></div>
        </div>

        <div class="common-cell lot-barcode-cell">
          <div>LOT BARCODE</div>
          <div style="width:300px;padding:5px 0px 0px 30px"></div>
          <div class="lot-and-ean">
            <span>${content?.EAN?.[0]?.split("*")[1] || ""}</span>
            <span>${content?.EAN?.[0]?.split("*")[0] || ""}</span>
          </div>

          <div style="width:300px;padding:5px 0px 0px 30px"></div>
          <div class="lot-and-ean">
            <span>${content?.EAN?.[1]?.split("*")[1] || ""}</span>
            <span>${content?.EAN?.[1]?.split("*")[0] || ""}</span>
          </div>

          <div style="width:300px;padding:5px 0px 0px 30px"></div>
          <div class="lot-and-ean">
            <span>${content?.EAN?.[2]?.split("*")[1] || ""}</span>
            <span>${content?.EAN?.[2]?.split("*")[0] || ""}</span>
          </div>

          <div class="carton-size-cell-new">
            ${content?.DIM?.length > 0
      ? `<h3>DIM : ${content?.DIM}</h3>`
      : `<h3>CARTON SIZES : ${content?.length || ""}*${content?.width || ""}*${content?.height || ""}</h3>`}
          </div>
        </div>
      </div>

      <div class="table-row">
        <div class="common-cell carton-size-cell" style="margin: 0">
          <hr class="hr-style-2" />
          <div style="display: flex; height: 50%; width: 100%">
            <div style="height: 44px; width: 74px; margin: 5px 0 0 -6px; padding: 0;">
              <h3 class="text_fixed">SIZES</h3>
            </div>
            ${sizeCells}
            <hr class="hr-style-3" />
            <div style="height: 44px; width: 74px; margin: 15px 0 0 20px; padding: 0;">
              <h3>TOTAL</h3>
            </div>
          </div>

          <hr class="hr-style-4" />

          <div style="display: flex; height: 100%; width: 100%; margin: 0; padding: 0;">
            <div style="height: 54px; width: 74px; margin: 5px 0 0 3px; padding: 0;">
              <h3>PIECES</h3>
            </div>
            ${pieceCells}
          </div>
        </div>
      </div>

    </div> <!-- /.table -->
  </div> <!-- /.qr-main-div (red border ends here) -->

  <!-- QR is OUTSIDE the red border, on the right side -->
  <div class="container_1_qr">
    <div class="qr-main">
      <div class="carton-id">${content?.carton_ID || ""}</div>
      <img src="${qrCode}" class="qr-code" alt="QR Code" />
    </div>
  </div>

</div>`;

  const htmlContent = `<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Complex Table with Flexbox</title>
    <style>

      /* ===== OUTER WRAPPER: border box + QR side by side ===== */
      .label-wrap {
        display: flex;
        align-items: flex-end;      /* QR aligns with bottom of the red border. Use flex-start for top */
        justify-content: flex-start;
      }

      /* ===== RED BORDER BOX (only holds the table) ===== */
      .qr-main-div {
        // border: 2px solid red;
        display: flex;
        flex-shrink: 0;
      }

      /* ===== QR AREA (outside the border) ===== */
      .container_1_qr {
        display: flex;
        margin-left: 8px;           /* gap between border and QR */
        flex-shrink: 0;             /* never squeeze the QR */
      }

      .qr-main {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 120px;
        padding-left: 1em;
        padding-bottom: 1em;
      }

      .qr-code {
        width: 100px;
        height: 100px;
        display: block;
      }

      .carton-id{
        font-weight: 500;
        font-size: 18px;
        width: fit-content;       
        white-space: nowrap;       
        // padding: 0 4px;
        // border: 1px solid black;
        text-align: left;
        margin-bottom: 4px
      }

      /* ===== TABLE ===== */
      .table-row {
        display: flex;
        align-items: start;
        padding: 0px;
      }

      .common-cell {
        display: flex;
        flex-direction: column;
        text-align: center;
      }

      .common-first-cell {
        display: flex;
        flex-direction: column;
        text-align: center;
        height: 130px;
      }

      .article-cell {
        padding: 10px;
        text-align: center;
        width: 594px;
        height: 140px;
        border: 1px solid #000;
        border-bottom: none;
      }
      .color-cell {
        padding: 10px;
        width: 103px;
        height: 140px;
        border: 1px solid #000;
        border-left: none;
      }
      .lot-cell {
        padding: 10px;
        width: 110px;
        height: 140px;
        border: 1px solid #000;
        border-left: none;
      }
      .lot-count-cell {
        padding: 10px;
        width: 115px;
        height: 140px;
        border: 1px solid #000;
        border-right: none !important;
        border-left: none !important;
      }
      .po-cell {
        padding: 10px;
        width: 250px;
        height: 140px;
        border: 1px solid #000;
      }

      .first-inner-div {
        flex: 1;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
      .first-inner-div-lot h2 {
        font-size: 21px;
        margin: 0 !important;
        padding: 0 !important;
        font-weight: 900 !important;
      }
      .first-inner-div-clr h2 {
        font-size: 21px;
        margin: 0 !important;
        padding: 0 !important;
        font-weight: 900 !important;
      }
      .first-inner-div-lots h2 {
        font-size: 25px;
        margin: 0 !important;
        padding: 0 !important;
        font-weight: 900 !important;
      }
      .first-inner-div-clr {
        flex: 1;
        justify-content: center;
        align-items: center;
        height: 100%;
      }

      .barcode-cell {
        padding: 10px 0 0 0;
        width: 594px;
        height: 260px;
        border: 1px solid #000;
        border-top: none;
      }

      .carton-and-qlt-pieces-cell {
        padding: 10px;
        margin-top: 5px;
        width: 150px;
        height: 95px;
        border: 1px solid #000;
        border-bottom: none;
        border-left: none !important;
      }

      .special-marking-cell-new {
        padding: 5px;
        width: 211px !important;
        min-height: 260px;
        border: 1px solid #000;
        border-top: none;
        border-right: none;
        border-left: none;
      }

      .gross-and-net-wt-cell {
        padding: 10px;
        margin-top: 5px;
        width: 150px;
        height: 95px;
        border: 1px solid #000;
        border-bottom: none;
        border-left: none !important;
      }

      .lot-barcode-cell {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        position: relative;
        padding: 10px;
        width: 367px !important;
        height: 260px;
        border: 1px solid #000;
        border-top: none;
      }

      .carton-size-cell {
        width: 1172px !important;
        height: 115px;
        border: 1px solid #000;
        border-top: none;
      }

      .volume-measure-cell {
        padding: 0 10px 0 10px;
        width: 212px;
        height: 85px;
        border: 1px solid #000;
        border-right: none;
        border-left: none;
        border-bottom: 1px solid #000;
      }

      .special-marking-cell {
        padding: 10px;
        width: 361px;
        height: 65px;
        border-top: none;
        border: 1px solid #000;
        border-left: none;
      }

      .carton-size-cell-new {
        padding: 6px 0 0 0;
        margin: 0 -10px 0 -10px;
        height: 40px;
        border: none;
        border-top: 2px solid #000;
        margin-top: auto;
      }
      .carton-size-cell-new h3 {
        font-size: 27px;
        font-weight: bolder;
      }

      h1, h2, h3 {
        margin: 0;
        font-size: 15px;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      h1 {
        font-size: 50px;
        font-weight: 900;
      }
      h2 {
        font-size: 30px;
        font-weight: 600;
      }

      .hr-style-1 {
        border: 1px solid #000;
        margin: 0px -20px 10px -18px;
      }
      .hr-style-2 {
        margin: 0px;
        width: 1170px;
        height: 1px;
        display: none;
      }
      .hr-style-3 {
        height: 113px;
        border: 1px solid #000;
        margin: -8px 0 0px 0;
      }
      .hr-style-4 {
        margin: 0px 0 0 0px;
        width: 1170px;
        padding: 3px !important;
      }

      .peiceDiv {
        height: 44px;
        width: 76px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .peiceDiv1 {
        height: 44px;
        width: 78px !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .peiceDiv2 {
        height: 44px;
        width: 79px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .peiceDiv3 {
        height: 44px;
        width: 129px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .tables-container {
        width: 100%;
        height: fit-content;
        overflow: visible;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
      }

      .lot-and-ean {
        margin-left: 28px;
        width: 300px;
        padding: 5px;
        display: flex;
        justify-content: space-between;
      }

      /* ===== CUT LINE ===== */
      .hr-style-16-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px;
        width: 1150px;
      }
      hr.style-16 {
        flex-grow: 1;
        border: none;
        border-top: 2px dashed black;
      }
      .hr-style-16-container span {
        display: inline-block;
        padding: 0 10px;
        background: #f0f0f0;
        font-size: 18px;
      }

    </style>
  </head>
  <body>
    <div class="tables-container">
      ${tbl}
      <div class="hr-style-16-container">
        <hr class="hr-style-16">
        <span>&#x2702;</span>
        <hr class="style-16">
      </div>
      ${tbl}
    </div>
  </body>
</html>`;

  return (
    <div
      style={{
        width: 'auto',
        height: 'auto',
        overflow: 'visible',
        zoom: scale,
        padding: "100px",
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    ></div>
  );
};

export default PreviewTeo;
